var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderFstSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6H17.3684V17.3684H6V6ZM30.6316 30.6316H42V42H30.6316V30.6316ZM30.3913 28.9771L27.2071 25.7929L25.7929 27.2071L28.9771 30.3913L30.3913 28.9771ZM21.6774 20.2632L25.6545 24.2403L24.2403 25.6545L20.2632 21.6774V25.8947H18.2632V19.2632V18.2632H19.2632H25.8947V20.2632H21.6774Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderFstSvgrepoCom);
export default __webpack_public_path__ + "static/media/provider-fst-svgrepo-com.cd7839bb9402301ee38abc9ba342a881.svg";
export { ForwardRef as ReactComponent };